module.exports = __webpack_public_path__ + "img/1.54618676.jpg";